import { LogLevel } from "@azure/msal-browser";
import { env } from "./utils/envConfig";

// ── Azure Entra ID → App registrations → <app> → Authentication → Redirect URIs ──
// Both deployment origins must be registered with the path /redirect:
//   https://<CHATBOT_FRONTEND_CUSTOM_DOMAIN>/redirect          (custom domain)
//   https://<CHATBOT_FRONTEND_APP_NAME>.azurewebsites.net/redirect  (Azure Web App)
// The redirectUri below is derived at runtime from window.location.origin so the
// same build works across both URLs without any env-var change. REACT_APP_REDIRECT_URL
// is kept as a fallback for non-browser environments (e.g. SSR, tests).

export const msalConfig = {
    auth:{
        clientId: env.REACT_APP_CLIENT_ID ?? '3044aef2-01be-4c57-8d2b-e8ae7b12b3dc',
        authority: env.REACT_APP_TENANT_ID?`https://login.microsoftonline.com/${env.REACT_APP_TENANT_ID}`:"https://login.microsoftonline.com/6e70803d-1d06-4a7f-964c-b357505dae97",
        redirectUri: `${(window.location.origin || env.REACT_APP_REDIRECT_URL || '').replace(/\/redirect\/?$/, '')}/redirect`,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
        }
    }
}

export const loginRequest = {
      scopes: [ "openid", "profile", "User.Read" ],
 };
export const tokenRequest = {
    scopes: [`${env.REACT_APP_CLIENT_ID}/.default`]
};
